import { Box, Grid, Link } from '@mui/material';
import BlockCarouselItemData from '../BlockCarouselItemData';
import CroppedImage from '../../../CroppedImage';
import EditableText from '../../../Form/EditableText';
import { BlockHeight } from '../../../../models/BlockSettings';

export interface CarouselItemProps {
  item: BlockCarouselItemData;
  handleOpen: () => void;
  maxHeight: number;
  isEditing?: boolean;
  blockHeight?: BlockHeight;
  useFixedAspectRatio?: boolean;
}

function CarouselItem({
  item,
  handleOpen,
  maxHeight,
  isEditing,
  useFixedAspectRatio = false,
  blockHeight,
}: CarouselItemProps) {
  return (
    <Box
      onClick={handleOpen}
      sx={{
        maxHeight: !useFixedAspectRatio ? maxHeight : undefined,
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: 1,
      }}
      >
        {item.text && (
          <Grid
            item
            sx={{
              zIndex: 1,
              position: 'absolute',
              padding: '12px',
              fontSize: '2rem',
            }}
          >
            <EditableText
              text={item.text.value}
              textColor={item.text.settings?.textColor}
              isEditable={false}
              updateHandler={() => { }}
            />
          </Grid>
        )}
      </Box>

      <Box sx={{ width: '100%', height: '100%' }}>
        {!isEditing ? (
          <Link
            style={{ cursor: item?.link?.linkData?.url ? 'pointer' : 'default' }}
            target={item?.link?.linkData?.openType}
            href={item?.link?.linkData?.url || undefined}
            rel="noreferrer"
          >
            <CroppedImage
              image={item.image}
              blockHeight={blockHeight}
              settings={item.image.settings}
              objectFitStyle={useFixedAspectRatio ? 'contain' : 'fill'}
              useFixedAspectRatio={useFixedAspectRatio}
            />
          </Link>
        ) : (
          <CroppedImage
            image={item.image}
            blockHeight={blockHeight}
            settings={item.image.settings}
            objectFitStyle={useFixedAspectRatio ? 'contain' : 'fill'}
            useFixedAspectRatio={useFixedAspectRatio}
          />
        )}
      </Box>
    </Box>
  );
}

export default CarouselItem;
